import React from 'react';
import styles from './IdqsOrderPage.module.scss';
import DataGrid, { Column, ColumnChooser, Scrolling, Sorting, StateStoring } from 'devextreme-react/data-grid';
import classNames from 'classnames';
import { Tooltip } from 'devextreme-react/tooltip';
import { TableFooter } from '../../components/TableFooter';
import { HeadTitle } from '../../components/HeadTitle';
import { Header } from '../../components/Header';
import { MasterDetailOrderGrid } from '../../components/MasterDetailOrderGrid';
import { IdqsOrderFilter } from '../IdqsOrderFilter';
import { getIdqsOrders, downloadIdqsOrders } from '../../api/idqsOrder';
import { Loading } from '../../components/Loading';
import { formatOrderDate } from '../../util/orderDataRenderFunctions';

const initialState = {
  queryParam: {},
  title: 'IDQS Order',
  isLoaded: false,
  isReloading: false,
  selectedRow: null,
  data: {},
  error: null,
  sort: {
    sortOn: '',
    sortDir: 'asc'
  }
};

var loadingOptions = {
  enabled: false
};

class IdqsOrderPage extends React.Component {
  constructor (props) {
    super(props);
    this.dataGridRef = React.createRef();
    let collapseOnSearch = window.localStorage.getItem('tps_collapseSearch') === 'true';
    this.state = {

      ...initialState,
      startDateUpdate: '',
      endDateUpdate: '',
      mpidUpdate: '',
      minPriceUpdate: '',
      maxPriceUpdate: '',
      startTimeUpdate: '',
      endTimeUpdate: '',
      symbolUpdate: '',
      orderIdUpdate: '',
      clientOrderIdUpdate: '',
      isDownloadInactive: false,
      isSearching: false,
      columnChooserTooltip: false,
      collapseOnSearch: collapseOnSearch

    };
    this.baseState = this.state;

    this.loadData = this.loadData.bind(this);

    this.setQueryParameters = this.setQueryParameters.bind(this);
    this.handleErrorResults = this.handleErrorResults.bind(this);
    this.clear = this.clear.bind(this);
    this.download = this.download.bind(this);
    this.showColumnChooserOptions = this.showColumnChooserOptions.bind(this);
    this.handleCellClickChange = this.handleCellClickChange.bind(this);
    this.addMenuItems = this.addMenuItems.bind(this);
  }

  showColumnChooserOptions () {
    if (this.dataGrid) {
      this.dataGrid.showColumnChooser();
    }
  }

  toggleColumnChooserTooltip = () => {
    this.setState({
      columnChooserTooltip: !this.state.columnChooserTooltip
    });
  }

  get dataGrid () {
    var gridRef;
    if (this.dataGridRef && this.dataGridRef.current) {
      gridRef = this.dataGridRef.current.instance;
    }
    return gridRef;
  }

  setQueryParameters (queryParamObj, type) {
    const isDownload = type === 'download';
    if (isDownload) {
      this.setState({ queryParam: queryParamObj }, this.download);
    } else {
      this.clear();
      // start the loading icon
      this.setState({ isSearching: true, hasMoreError: null });
      // get only specific trades
      this.setState({ queryParam: queryParamObj }, this.loadData);
    }
  }

  loadData () {
    var filters = this.state.queryParam;
    var sort = this.state.sort;
    getIdqsOrders(filters, sort)
      .then(data => {
        //  console.log(data);
        this.setState(prevState => ({
          isLoaded: true,
          isReloading: false,
          hasMoreError: data.hasMoreError,
          data: data
        }));
      })
      .catch((error) => {
        // error
        console.log(error);
        var message = (error && error.response &&
          error.response.data && error.response.data) || 'Data currently unavailable';
        this.handleErrorResults(message);
      });
  }

  clear () {
    this.setState(this.baseState);
  }

  download () {
    if (this.state.isDownloadInactive) return;
    // make it inactive for future request until current one is solved
    this.setState({ isDownloadInactive: true });
    // download order data
    var filters = this.state.queryParam;
    downloadIdqsOrders(filters).then(data => {
      this.setState({ isDownloadInactive: false });
    })
      .catch((err) => {
        // error
        this.setState({ isDownloadInactive: false });
        console.log(err);
      });
  }

  // handle sorting
  handleCellClickChange (e) {
    // console.log(e);

    if (e.rowType === 'header' && e.column.allowSorting) {
      var newSortField = e.column.dataField;
      var currentSortField = this.state.sort.sortOn;
      var currentSortDir = this.state.sort.sortDir;
      // assume its new field,there fore direction would be asc
      var sortDir = 'asc';
      if (newSortField === currentSortField && currentSortDir === 'asc') {
        sortDir = 'desc';
      }

      // this.dataGrid.columnOption(currentSortField, 'sortOrder', void 0);
      // this.dataGrid.columnOption(newSortField, 'sortOrder', sortDir);
      this.setState(prevState => ({
        isReloading: true,
        sort: {
          sortOn: newSortField,
          sortDir: sortDir
        }

      }), this.loadData);
    } else if (e.row && e.row.rowType === 'data') {
      const column = e.column;
      if (column && column.dataField === 'clientOrderId') {
        this.setState({ selectedRow: e.row.data });
      }
    }
  }

  handleErrorResults (errorMessage) {
    this.setState(prevState => ({
      isLoaded: true,
      isReloading: false,
      data: {},
      selectedRow: null,
      hasMoreError: null,
      sort: {
        sortOn: '',
        sortDir: 'asc'
      },
      error: errorMessage
    }));
  }

  addMenuItems (e) {
    //  console.log(e.column.dataField);
    if (e.column && e.row && e.column.dataField === 'mpid' && e.row.rowType === 'data') {
      // e.items can be undefined
      if (!e.items) e.items = [];

      // Add a custom menu item
      e.items.push({
        text: 'Add to Mpid',
        icon: 'add',
        onItemClick: () => {
          //  console.log(e.row.data.mpid);
          this.setState({
            mpidUpdate: e.row.data.mpid
          });
        }
      });
    } else if (e.column && e.row && e.column.dataField === 'symbol' && e.row.rowType === 'data') {
      // e.items can be undefined
      if (!e.items) e.items = [];

      // Add a custom menu item
      e.items.push({
        text: 'Add to Symbol',
        icon: 'add',
        onItemClick: () => {
          this.setState({
            symbolUpdate: e.row.data.symbol
          });
        }
      });
    } else if (e.column && e.row && e.column.dataField === 'orderId' && e.row.rowType === 'data') {
      // e.items can be undefined
      if (!e.items) e.items = [];

      // Add a custom menu item
      e.items.push({
        text: 'Add to Order ID',
        icon: 'add',
        onItemClick: () => {
          this.setState({
            orderIdUpdate: e.row.data.orderId
          });
        }
      });
    } else if (e.column && e.row && e.column.dataField === 'clientOrderId' && e.row.rowType === 'data') {
      // e.items can be undefined
      if (!e.items) e.items = [];

      // Add a custom menu item
      e.items.push({
        text: 'Add to Client Order ID',
        icon: 'add',
        onItemClick: () => {
          this.setState({
            clientOrderIdUpdate: e.row.data.clientOrderId
          });
        }
      });
    } else if (e.column && e.row && e.column.dataField === 'orderDate' && e.row.rowType === 'data') {
      // e.items can be undefined
      if (!e.items) e.items = [];
      let value = e.row.data.orderDate;
      // Add a custom menu item
      e.items.push({
        text: 'Add to Start Date',
        icon: 'add',
        onItemClick: () => {
          this.setState({
            startDateUpdate: value
          });
        }
      });
      e.items.push({
        text: 'Add to End Date',
        icon: 'add',
        onItemClick: () => {
          this.setState({
            endDateUpdate: value
          });
        }
      });
    } else if (e.column && e.row && e.column.dataField === 'price' && e.row.rowType === 'data') {
      // e.items can be undefined
      if (!e.items) e.items = [];
      let value = e.row.data.price;
      // Add a custom menu item
      e.items.push({
        text: 'Add to Min Order Price',
        icon: 'add',
        onItemClick: () => {
          this.setState({
            minPriceUpdate: value
          });
        }
      });
      e.items.push({
        text: 'Add to Max Order Price',
        icon: 'add',
        onItemClick: () => {
          this.setState({
            maxPriceUpdate: value
          });
        }
      });
    } else if (e.column && e.row && e.column.dataField === 'updatedTime' && e.row.rowType === 'data') {
      // e.items can be undefined
      if (!e.items) e.items = [];
      let value = e.row.data.updatedTime;
      // Add a custom menu item
      e.items.push({
        text: 'Add to Updated Start Time',
        icon: 'add',
        onItemClick: () => {
          this.setState({
            startTimeUpdate: value
          });
        }
      });
      e.items.push({
        text: 'Add to Updated End Time',
        icon: 'add',
        onItemClick: () => {
          this.setState({
            endTimeUpdate: value
          });
        }
      });
    }
  }

  renderOrderDetails = props => {
    return <MasterDetailOrderGrid data={props.data} filter={this.state.queryParam} context='idqs' clearSelection={this.clearSelection} />;
  };

  clearSelection = e => {
    this.setState({ selectedRow: null });
  }

  render () {
    const data = this.state.data;
    const isDataLoaded = this.state.isLoaded && data && data.results && data.results.length > 0;

    return (
      <div>
        <HeadTitle title={this.state.title} />
        <Header title={this.state.title} />
        <IdqsOrderFilter search={this.setQueryParameters}
          mpidUpdate={this.state.mpidUpdate}
          startDateUpdate={this.state.startDateUpdate}
          endDateUpdate={this.state.endDateUpdate}
          symbolUpdate={this.state.symbolUpdate}
          orderIdUpdate={this.state.orderIdUpdate}
          clientOrderIdUpdate={this.state.clientOrderIdUpdate}
          minPriceUpdate={this.state.minPriceUpdate}
          maxPriceUpdate={this.state.maxPriceUpdate}
          startTimeUpdate={this.state.startTimeUpdate}
          endTimeUpdate={this.state.endTimeUpdate}
          isDataLoaded={isDataLoaded}
          isDownloadInactive={this.state.isDownloadInactive}

        />

        {this.state.hasMoreError && this.state.hasMoreError !== '' &&
        <div className={styles.warning}>{this.state.hasMoreError}</div>}

        {this.state.isSearching && <Loading
          type='table'
          data={data.results}
          loaded={this.state.isLoaded}
          reloading={this.state.isReloading}
          error={this.state.error}
          emptyMessage='No results found.' >
          <div>
            <div className={styles.tableMenu}>
              <i
                id='column-chooser'
                className={classNames(styles.columnChooser, 'dx-icon-columnchooser')}
                onClick={this.showColumnChooserOptions}
                onMouseEnter={this.toggleColumnChooserTooltip}
                onMouseLeave={this.toggleColumnChooserTooltip}
              />
              <Tooltip
                target={'#column-chooser'}
                position='left'
                visible={this.state.columnChooserTooltip}
                hideOnOutsideClick={false}
              > Open Column Chooser</Tooltip>
            </div>
            <DataGrid
              id='idqsOrderGridContainer'
              className={classNames(styles.gridContainer, {
                [styles.collapseGrid]: this.state.collapseOnSearch
              })}
              ref={this.dataGridRef}
              dataSource={data.results}
              allowColumnReordering
              hoverStateEnabled
              columnAutoWidth
              rowAlternationEnabled
              showBorders
              repaintChangesOnly
              loadPanel={loadingOptions}
              onContextMenuPreparing={this.addMenuItems}
              onCellClick={this.handleCellClickChange}
            >
              <Scrolling mode='infinite' rowRenderingMode='virtual' preloadEnabled />
              <Sorting mode='none' />
              <Column dataField='orderDate' caption='Date' calculateDisplayValue={formatOrderDate} />
              <Column dataField='orderTime' caption='Entered' />
              <Column dataField='updatedTime' caption='Updated' />
              <Column dataField='mpid' caption='MPID' />
              <Column dataField='symbol' caption='Symbol' />
              <Column dataField='destination' caption='Dest.' allowSorting={false} />
              <Column dataField='status' caption='Ord Status' />
              <Column dataField='text' caption='Text' allowSorting={false} />
              <Column dataField='side' caption='Side' allowSorting={false} />
              <Column dataField='quantity' caption='Qty' dataType='string' alignment='right' />
              <Column dataField='showQty' caption='Show Qty' allowSorting={false} dataType='string' alignment='right' />
              <Column dataField='price' caption='Price 'dataType='string' alignment='right' />
              <Column dataField='capacity' caption='Capacity' allowSorting={false} />
              <Column dataField='execQty' caption='Exec Qty' dataType='string' alignment='right' />
              <Column dataField='linkAtsId' caption='Link ATS ID' allowSorting={false} />
              <Column dataField='leavesQty' caption='Lvs Qty' allowSorting={false} dataType='string' alignment='right' />
              <Column dataField='clientTif' caption='TIF' allowSorting={false} />

              <Column dataField='clientOrderId' caption='Cl Ord ID' allowSorting={false} cssClass={styles.cellHighlight} showInColumnChooser={false} />

              <Column dataField='orderId' caption='Ord ID' />
              <Column dataField='orderType' caption='Ord Type' allowSorting={false} visible={false} />
              <Column dataField='pegType' caption='Peg Type' allowSorting={false} visible={false} />
              <Column dataField='fixTag2' caption='Exec Inst.' allowSorting={false} visible={false} />
              <Column dataField='userId' caption='Fix Session' allowSorting={false} visible={false} />
              <Column dataField='contraOrderId' caption='Contra Ord ID' allowSorting={false} visible={false} />

              <Column dataField='tradeSession' caption='Trade Session' allowSorting={false} visible={false} />
              <Column dataField='senderTraderId' caption='Sender Trader' allowSorting={false} visible={false} />
              <Column dataField='unsolicited' caption='Unsolicited' allowSorting={false} visible={false} />
              <Column dataField='insideBid' caption='Inside Bid' allowSorting={false} visible={false} />
              <Column dataField='insideAsk' caption='Inside Ask' allowSorting={false} visible={false} />
              <Column dataField='routeId' caption='Route ID' allowSorting={false} visible={false} />
              <Column dataField='fixTags' caption='FixTags' allowSorting={false} visible={false} />

              <ColumnChooser enabled allowSearch mode='select' title='Select Column(s)' />
              <StateStoring enabled type='localStorage' storageKey='userIdqsOrderColumns' savingTimeout={10} />
              {/*<MasterDetail enabled render={this.renderOrderDetails} />*/}
            </DataGrid>
            <TableFooter totalResults={data && data.results && data.results.length} />
            <div id='notes' className={styles.textNoteContainer}>
              <div id='note1' className={styles.textNote}>Messages are ordered by default in the order received from IDQS API</div>
              <div id='note2' className={styles.textNote}>* Includes a status generated by the OTC internal systems</div>
            </div>
          </div>
        </Loading> }
        {this.state.selectedRow && <MasterDetailOrderGrid data={this.state.selectedRow} filter={this.state.queryParam} context='idqs' clearSelection={this.clearSelection} />}
      </div>
    );
  }
}
export default IdqsOrderPage;
